<div class="filter-multi-select" [class.open]="isOpen">
  <button
    #triggerBtn
    type="button"
    class="filter-trigger"
    (click)="toggle()"
    [attr.aria-expanded]="isOpen"
  >
    <span class="filter-trigger-text">{{ displayText || placeholder }}</span>
    <mat-icon class="filter-trigger-icon">{{
      isOpen ? "expand_less" : "expand_more"
    }}</mat-icon>
  </button>
</div>

<ng-template #dropdownTemplate>
  <div class="filter-dropdown-panel">
    <div class="filter-search-wrap">
      <mat-icon class="filter-search-icon" aria-hidden="true">search</mat-icon>
      <input
        #searchInput
        type="text"
        class="filter-search-input"
        [placeholder]="searchPlaceholder"
        [ngModel]="searchQuery"
        (ngModelChange)="onSearchInput($event)"
        autocomplete="off"
      />
      @if (searchQuery) {
      <button
        type="button"
        class="filter-search-clear"
        aria-label="Ryd søgning"
        (click)="clearSearch($event)"
      >
        <mat-icon aria-hidden="true">close</mat-icon>
      </button>
      }
    </div>
    @if (options.length > 0) {
    <mat-selection-list
      class="filter-selection-list"
      [ngModel]="selectedValues"
      (ngModelChange)="onSelectionChange($event)"
      multiple
    >
      @for (option of options; track option.value) {
      <mat-list-option [value]="option.value" togglePosition="before">
        <span class="option-row">
          <span class="option-label" [title]="option.label">{{ option.label }}</span>
          @if (option.facetCount !== undefined) {
          <span
            class="facet-count"
            [class.is-zero]="option.facetCount === 0"
            >{{ option.facetCount }}</span
          >
          }
        </span>
      </mat-list-option>
      }
    </mat-selection-list>
    } @else {
    <div class="filter-empty-state">Ingen resultater</div>
    }
  </div>
</ng-template>
